import { z } from 'zod'

/**
 * Types and schemas for unit-related Firebase Functions
 */

// Zod schema for CreateUnitRequest validation
export const CreateUnitRequestSchema = z.object({
  siteId: z.string().min(1, 'Site ID is required'),
  buildingDesignation: z
    .string()
    .min(1, 'Building designation is required')
    .max(100, 'Building designation must be less than 100 characters'),
})

export type CreateUnitRequest = z.infer<typeof CreateUnitRequestSchema>

export interface CreateUnitResponse {
  unitId: string
  message: string
}

// Move unit between sites
export const MoveUnitRequestSchema = z.object({
  sourceSiteId: z.string().min(1, 'Source site ID is required'),
  targetSiteId: z.string().min(1, 'Target site ID is required'),
  unitId: z.string().min(1, 'Unit ID is required'),
  companyId: z.string().min(1).optional(),
  dryRun: z.boolean().optional(),
})

export type MoveUnitRequest = z.infer<typeof MoveUnitRequestSchema>

export interface MoveUnitPreview {
  totalDocuments: number
  subcollectionCounts: Record<string, number>
}

export interface MoveUnitResponse {
  unitId: string
  targetSiteId: string
  movedDocuments: number
  message: string
  preview?: MoveUnitPreview
}
